/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]];
const ArrowBigDown = createLucideIcon("ArrowBigDown", __iconNode);

export { __iconNode, ArrowBigDown as default };
//# sourceMappingURL=arrow-big-down.js.map
